import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=fd090cd8&scoped=true&"
import script from "./AdminBar.vue?vue&type=script&lang=ts&"
export * from "./AdminBar.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBar.vue?vue&type=style&index=0&id=fd090cd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd090cd8",
  null
  
)

export default component.exports